// import Swiper from "swiper"
import { find } from "../utils/dom"
import gsap from "gsap"

export default function () {
	const Home = find("[js-page='adult-programs']")
	if (!Home) return
	console.log('Page Adults Programs');


const swiperAdultsProgram = new Swiper(".swiper-adults-program", {
	spaceBetween: 16,
	slidesPerView: 4,
	centeredSlides:true,
	initialSlide: 2,
	//loop:true,

	navigation: {
		nextEl: ".swiper-button-adults-program-next",
		prevEl: ".swiper-button-adults-program-prev",
	},

	breakpoints:{
		600:{
			slidesPerView: 'auto',
			spaceBetween:24,
		},
		375: {
      		slidesPerView: 'auto',
      		centeredSlides: true,
      		initialSlide: 0,
      		spaceBetween: 16,
    	}
	}
});

const swiperAdultsProgramMobile = new Swiper(".swiper-adults-program-mobile", {
	slidesPerView: 'auto',
	spaceBetween: 20,
	freeMode: true,
});

function btnToggleMobile () {
	const btn = document.querySelector('.item-toggle-adults')

	btn?.addEventListener('click', ()=>{
		const svg = btn.querySelector('svg')
		const paragraph = btn.querySelector('p')
		paragraph.classList.toggle('disable')
		svg.classList.toggle('rotate-180')
	})
}

btnToggleMobile()

const animaRotateImage = () =>{
	gsap.to("#rotatingText2", {
      rotation: 360,
      duration: 10,
      repeat: -1,
      ease: "linear",
      transformOrigin: "50% 50%"  // gira em torno do centro
    });
}

animaRotateImage()

}